<template>
    <div class="jr-component">
      <span class="jr-labelwhere" v-bind="$attrs" :id="id" :title="headValue + whereValue" :style="'width: ' + width + ';'">{{ headValue + whereValue }}</span>
    </div>
</template>
<script>
import JRGLOBAL from '@/api/jrglobal'
export default {
  name: 'JrLabelwhere',
  computed: {
    whereValue() {
      let whereValue = ''
      if(this.queryData !== undefined){
        for (var key in this.queryData) {
          if((this.queryData[key].controlDefaultvalue != '' || this.queryData[key].controlLiketype == '!N' || this.queryData[key].controlLiketype == 'NN') && this.queryData[key].controlName != '' && this.queryData[key].controlType != 'Select' && this.queryData[key].controlType != 'SelectType'){
            whereValue = whereValue + this.queryData[key].controlDisplayname 
            + this.likeTypes[this.queryData[key].controlLiketype] 
            + ((this.queryData[key].controlLiketype == '!N' || this.queryData[key].controlLiketype == 'NN') ? ',' : '[' + this.queryData[key].controlDefaultvalue + '],')
          }
          if((this.queryData[key].controlDefaultvalue != '' || this.queryData[key].controlLiketype == '!N' || this.queryData[key].controlLiketype == 'NN') && (this.queryData[key].controlType == 'Select' || this.queryData[key].controlType == 'SelectType')){
            whereValue = whereValue + this.queryData[key].controlDisplayname 
            + this.likeTypes[this.queryData[key].controlLiketype] 
            + ((this.queryData[key].controlLiketype == '!N' || this.queryData[key].controlLiketype == 'NN') ? ',' : '[' + this.queryData[key].controlDefaultlabel + '],')
          }
        }
      }
      return whereValue.substr(0,whereValue.length-1) + (whereValue.length > 0 ? '。' : '')
    }
  },
  data() {
    return {
      likeTypes: JRGLOBAL.likeTypes
    }
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    headValue:{
      type: String,
      default: '条件：'
    },
    width: {
      type: String,
      default: '100%'
    },
    queryData: {}
  }
}
</script>
<style scoped lang="scss">
  .jr-labelwhere{
    word-break:break-all;
    display:-webkit-box;/**对象作为伸缩盒子模型展示**/
    -webkit-box-orient:vertical;/**设置或检索伸缩盒子对象的子元素的排列方式**/
    -webkit-line-clamp:1;/**显示的行数**/
    overflow:hidden;/**隐藏超出的内容**/
    color: red;
    font-size: 14px;
  }

  

</style>


// WEBPACK FOOTER //
// src/components/componentsjr/JrLabelwhere.vue